import http from "./http";
const api_url = process.env.REACT_APP_API_URL;

export async function loginUser(user_info) {
  try {
    const url = `${api_url}/login`;
    const response = await http.post(url, user_info);

    const { data: user, success } = response.data;

    if (success) {
      await login_user_locally(user); // Await the local storage update

      // setting pos items
      return user;
    } else {
      throw new Error("Email or password is invalid");
    }
  } catch (error) {
    throw new Error(error.response ? error.response.data : error.message);
  }
}

export function login_user_locally(user_data) {
  return new Promise((resolve, reject) => {
    try {
      localStorage.setItem("tealbo_vendor", JSON.stringify(user_data));
      resolve("User data stored successfully");
    } catch (error) {
      reject("Failed to store user data");
    }
  });
}

export function logout() {
  localStorage.removeItem("tealbo_vendor");
}

export function getCurrentUser() {
  try {
    const user = localStorage.getItem("tealbo_vendor");
    if (!user) return null;
    return JSON.parse(user);
  } catch (ex) {
    return null;
  }
}
